import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import QuestionSection from "Components/Utilities/QuestionSection";

import { User } from "Services";
import { asset } from "Services/BaseHelpers";

export default class Hotel extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        const group = User.data?.groups[0]?.name ?? ' I&O';

        return (
            <Authenticated title="Dashboard">
                {group === 'I&O' && (<HotelGroupIO />)}
                {group === 'HOB' && (<HotelGroupHOB />)}
            </Authenticated>
        );
    }
}

class HotelGroupIO extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <>
                <PageHeader
                    title={"The Hotel"}
                    imgSrc={'hotel.png'}
                />

                {this.renderOpeningTextSection()}
                {this.renderMapSection()}
                {this.renderFacilitesSection()}

                <div className="relative">
                    <img src={asset('images/hotel_view_io.png')} />

                    <div className="absolute text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 uppercase">
                        <h1 className="text-3xl text-center tracking-widest bmw-condenced-bold">
                            CHECK-IN & CHECK-OUT
                        </h1>
                        <h1 className="text-md text-center mt-4 tracking-widest bmw-condenced-sb">
                            Check-in is 14:00 and check-out is 11.00
                        </h1>
                    </div>
                </div>

                <QuestionSection />
            </>
        );
    }

    /**
     * @method renderOpeningTextSection
     * @return {*}
     */
    renderOpeningTextSection () {
        return (
            <Section>
                <p className="bmw-condenced-bold text-2xl">
                    ONE&ONLY CAPE TOWN
                </p>
                <p className="bmw-light">
                    As part of the Owner, Investor and Franchise Director group, you will be staying at One&Only Cape Town.
                    <br />
                    Please note that the Heads of Business will be staying at the Mount Nelson. However, you will be joining together on
                    all aspects of the main programme and any optional activities you wish to do together.
                </p>
                <img className="mx-auto my-auto" src={asset('images/cape_town.png')} />

                <p className="bmw-light">
                    With the V&A Waterfront on your front doorstep and Table Mountain in your backyard,
                    your stay at One&Only Cape Town ensures that you can easily enjoy what this vibrant city has to offer.
                </p>

                <p className="bmw-light">
                    Inside, the hotel is truly breath-taking from every angle, with each room showcasing unprecedented
                    levels of luxury, style and views of the mighty Table Mountain.
                    Gastronomy and wine are taken seriously at this hotel, with a selection of stunning restaurants and
                    bar lounges that showcase the finest examples of South Africa’s culinary heritage.
                </p>
            </Section>
        );
    }

    /**
     * @method renderMapSection
     * @return {*}
     */
    renderMapSection () {
        return (
            <div className="max-w-full mx-auto text-center space-y-6 my-auto">
                <div className="grid grid-cols-2 gap-0 text-white">
                    <div className="w-full bg-location bg-cover h-full">
                        <div className="my-auto mx-auto flex flex-col justify-center text-right h-full space-y-6 pl-64 pr-12">
                            <div className="bmw-condenced-regular text-2xl w-full">
                                LOCATION
                            </div>

                            <div className="bmw-condenced-regular w-full">
                                Set overlooking the iconic Waterfront and only a scenic 25-minutes from Cape Town International Airport.
                                One&Only Cape Town overlooks the marina with panoramic views of Table Mountain,
                                offering the perfect base of tranquillity and inner-city luxury.
                            </div>
                        </div>
                    </div>

                    <div className="font-bold text-2xl my-auto mx-auto w-full">
                        <iframe
                            width="100%"
                            height="600"
                            frameBorder="0"
                            scrolling="no"
                            marginHeight="0"
                            marginWidth="0"
                            src="https://maps.google.com/maps?q=One%20and%20Only,%20hotel,%20Cape%20Town,%20South%20Africa&t=&z=13&ie=UTF8&iwloc=&output=embed"
                        ></iframe>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderFacilitesSection
     * @return {*}
     */
    renderFacilitesSection () {
        return (
            <Section>
                <div>
                    <p className="bmw-condenced-bold text-2xl my-5">
                        FACILITIES
                    </p>

                    <p className={"bmw-condenced-bold my-5"}>
                        All guest rooms are styled with an African flair and a private balcony
                        offers inimitable views of Table Mountain, the magnificent Marina, or both.
                    </p>

                    <p className="bmw-light my-5">
                        The Vista Bar and Lounge offers live entertainment and unfettered mountain views from afternoon to night.
                        Let the expert mixologists personalise your cocktail.
                    </p>

                    <p className="bmw-light my-5">
                        Choose from a curated selection of restaurants and savour exceptional cuisine
                        and rare wines in the most stylish spaces in town.
                    </p>

                    <p className="bmw-light my-5">
                        Rebalance and realign with bespoke treatments at One&Only Spa, salon pampering at StudiO,
                        and fitness activities for total mind-body wellbeing. Or simply stretch out on your sun-lounger
                        and soak up the sun by the infinity pool, tucked away on a private island in the midst of the resort.
                    </p>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 my-4">
                        <div>
                            <img className="mx-auto my-auto h-44" src={asset('images/hotel_beds.jpg')} />
                        </div>
                        <div>
                            <img className="mx-auto my-auto h-44" src={asset('images/hotel_view.png')} />
                        </div>
                        <div>
                            <img className="mx-auto my-auto h-44" src={asset('images/hotel_bed.png')} />
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

class HotelGroupHOB extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <>
                <PageHeader
                    title={"The Hotel"}
                    imgSrc={'hotel.png'}
                />

                {this.renderOpeningTextSection()}
                {this.renderMapSection()}
                {this.renderFacilitesSection()}

                <div className="relative">
                    <img src={asset('images/hotel_view_hob.png')} />

                    <div className="absolute text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 uppercase">
                        <h1 className="text-3xl text-center tracking-widest bmw-condenced-bold">
                            CHECK-IN & CHECK-OUT
                        </h1>
                        <h1 className="text-md text-center mt-4 tracking-widest bmw-condenced-sb">
                            Check-in is 15:00 and check-out is 11.00
                        </h1>
                    </div>
                </div>

                <QuestionSection />
            </>
        );
    }

    /**
     * @method renderOpeningTextSection
     * @return {*}
     */
    renderOpeningTextSection () {
        return (
            <Section>
                <p className="bmw-condenced-bold text-2xl">
                    Mount Nelson Belmond Hotel
                </p>
                <p className="bmw-light">
                    As part of the Heads of Business group, you will be staying at the Mount Nelson Belmond Hotel.
                    Please note that the Owner, Investor and Franchise Director group will be staying at One&Only Cape Town.
                    However, you will be joining together on all aspects of the main programme and any optional activities you wish to do together.
                </p>

                <img className="mx-auto my-auto" src={asset('images/group-2-hotel-4.jpg')} />

                <p className="bmw-light">
                    The Mount Nelson, A Belmond Hotel, has been captivating visitors since it first opened in Cape Town
                    in 1899. Nestled between the slopes of Table Mountain and the vibrant city, get ready to enter a
                    world of relaxation and glamour, as you soon as you enter the gates.
                </p>

                <p className="bmw-light">
                    With pioneering gastronomy with local roots and close collaboration with South Africa’s creative
                    community, the Nellie has a vintage heart and innovative spirit with easy access to the city.
                </p>
            </Section>
        );
    }

    /**
     * @method renderMapSection
     * @return {*}
     */
    renderMapSection () {
        return (
            <div className="max-w-full mx-auto text-center space-y-6 my-auto">
                <div className="grid grid-cols-2 gap-0 text-white">
                    <div className="w-full bg-location bg-cover h-full">
                        <div className="my-auto mx-auto flex flex-col justify-center text-right h-full space-y-6 pl-64 pr-12">
                            <div className="bmw-condenced-regular text-2xl w-full">
                                LOCATION
                            </div>

                            <div className="bmw-condenced-regular w-full space-y-4">
                                <p>
                                    Take a stroll inland from the waterfront and you’ll soon stumble upon the aptly
                                    named Gardens suburb. Once home to essential farmland, this district is now a
                                    thriving cosmopolitan hub. Old-world charm meets a cool urban edge that seems to
                                    flow forth from Kloof Street.
                                </p>

                                <p>
                                    Just a stone’s throw away, you’ll find the Mount Nelson Belmond Hotel, a visual symbol for the Gardens’ spirit.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="font-bold text-2xl my-auto mx-auto w-full">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3310.352335230146!2d18.411655!3d-33.93206500000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc67711ea099d9%3A0x8c90297be5ceb239!2sMount%20Nelson%2C%20A%20Belmond%20Hotel%2C%20Cape%20Town!5e0!3m2!1sen!2suk!4v1676045592840!5m2!1sen!2suk"
                            width="100%"
                            height="600"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderFacilitesSection
     * @return {*}
     */
    renderFacilitesSection () {
        return (
            <Section>
                <div>
                    <p className="bmw-condenced-bold text-2xl my-5">
                        FACILITIES
                    </p>

                    <p className={"bmw-condenced-bold my-5"}>
                        Follow in the footsteps of Winston Churchill, John Lennon and Nelson Mandela with a stay in this
                        iconic retreat.
                    </p>

                    <p className="bmw-light my-5">
                        Each unique bedroom boasts a sense of understated style throughout the main building and across
                        the beautiful grounds.
                    </p>

                    <p className="bmw-light my-5">
                        Indulge in a feast of bite-size treats with a delicious seasonal picnic. Take time over an
                        afternoon tea layered with tempting sandwiches and sweets. Or raise a toast with chic cocktails
                        in our Planet Bar. Boasting some of the best restaurants and bars in Cape Town, a stay at Mount
                        Nelson is foodie heaven.
                    </p>

                    <p className="bmw-light my-5">
                        Unwind and indulgent in the Librisa Spa, a tranquil space complete with Finnish sauna. The
                        fitness centre complete with start of the equipment is open 24 hours a day. Or take a dip in one
                        of the outdoor heated pools.
                    </p>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 my-4">
                        <div>
                            <img className="mx-auto my-auto h-44" src={asset('images/group-2-hotel-1.jpg')} />
                        </div>
                        <div>
                            <img className="mx-auto my-auto h-44" src={asset('images/group-2-hotel-2.jpg')} />
                        </div>
                        <div>
                            <img className="mx-auto my-auto h-44" src={asset('images/group-2-hotel-3.jpg')} />
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}
